import { render } from "./Objectives.vue?vue&type=template&id=cb6aaf24&scoped=true"
import script from "./Objectives.vue?vue&type=script&lang=js"
export * from "./Objectives.vue?vue&type=script&lang=js"

import "./Objectives.vue?vue&type=style&index=0&id=cb6aaf24&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6aaf24"]])

export default __exports__